import {mappedAddressTypes} from 'presentation/constants';

export function getAddressByGroups(address: string) {
	const [addressType, ...addressNameParts] = address.trim().split(/\s+/);
	const addressName = addressNameParts.join(' ').slice(0, 100);

	if (addressType && addressName) {
		const sanitizedAddressType = addressType.trim().replace(/\W/, '');
		const addressTypeToUppercase = sanitizedAddressType.toUpperCase();

		const mappedAddressType = mappedAddressTypes.find(item => {
			const foundItem = item.dsTipoLogradouro.includes(addressTypeToUppercase);
			return foundItem ? item.cdTipoLogradouro : '';
		});

		return {
			addressType: mappedAddressType?.cdTipoLogradouro || addressType,
			addressName,
		};
	}

	return {
		addressType: '',
		addressName: address.trim(),
	};
}
